import { unsetFocus } from '../../dataStore/actions/room/room'
import setupActions from '../../dataStore/actions/setup'
import { removeSeatFromMap } from '../../dataStore/actions/seatingOrder/seatingOrderSyncFunctions'
import { applyBackground } from '../../lib/virtualBackground'
import { VirtualBackgrounds } from '../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'
import { addEntry } from '../../lib/audit'

export default function ({ getState, dispatch }) {

  navigator.mediaDevices.ondevicechange = () => dispatch(setupActions.setAvailableDevices())

  window.addEventListener('beforeunload', async ev => {

    const { room: { room, focusOn }, user } = getState()

    addEntry('PresenterService', 'UserLeavingThePage', `${user.data.firstName} ${user.data.lastName} leaving the page - user_id:${user.BTID}`, 'info', user.BTID)

    if (room) {

      const { identity } = room.localParticipant

      if (identity) removeSeatFromMap(identity)

      if (Reflect.has(room, 'disconnect')) {

        //for some reason if we disconnect while still having the background activated hangs the browser tab
        //so we search for a video processor and if there is one we remove it
        if (room.localParticipant.videoTracks) {
          room.localParticipant.videoTracks.forEach(publication => {

            if (publication.track.processor) {
              applyBackground(publication.track, { customImage: null, type: VirtualBackgrounds.NONE })
            }
  
          })
        }

        room.disconnect()

      }

    }

    if (focusOn === user.BTID) dispatch(unsetFocus())

  })

}
